import styled from 'styled-components';
import { RawButton } from '../../../Button/Button.styles';

interface BreadcrumbProps {
  isActive: boolean;
}

export const Breadcrumb = styled(RawButton)<BreadcrumbProps>(({ theme, isActive }) => ({
  fontFamily: theme.fontFamily,
  fontSize: theme.fontSizes.body,
  fontWeight: 500,
  color: isActive ? theme.colors.neutral['500'] : theme.colors.primary['500'],
  padding: '2px 8px',
  lineHeight: '20px',
  borderRadius: theme.radii.medium,
  transition: `background ${theme.transitions.normal}, color ${theme.transitions.normal}`,
  whiteSpace: 'nowrap',

  '&[data-focus-visible-added]:not(.disabled):focus': {
    outline: 'none',
    boxShadow: !isActive
      ? `0px 0px 0px 2px ${theme.colors.primary['300']}, inset 0px 0px 0px 1px ${theme.colors.primary['500']}`
      : 'none',
    zIndex: 1,
  },

  '&:not(.disabled):hover': {
    background: !isActive && theme.colors.primary['100'],
    color: !isActive && theme.colors.primary['600'],
    cursor: isActive ? 'default' : 'pointer',
  },
}));
